module.exports = __webpack_public_path__ + "app-static/img/icon-gl.9ebaddbc.png";